export enum SHARED_LINK_KEYS {
  SHARED_LINK = 'shared-link',
}
